import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { AuthenticationModule } from 'src/app/authentication/authentication.module';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-organisation-toolbar',
  imports: [SharedModule, AuthenticationModule, MatButtonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './organisation-toolbar.component.html',
})
export class OrganisationToolbarComponent {
  constructor(
    private _router: Router,
  ) { }

  addRecord() {
    this._router.navigate(['/organisations/new/root']).then(_ => _);
  }
}
